// extracted by mini-css-extract-plugin
export default {"highlight":"Hightlight_highlight__lqZFy","searchHighlight":"Hightlight_searchHighlight__DlAf8","pRelative":"Hightlight_pRelative__6HKPz"};